export enum CurrentDialogEnum {
  'CloudStorageDlg' = 'CloudStorageDlg',
  'FileMoveDlg' = 'FileMoveDlg',
  'DeleteFileDlg' = 'DeleteFileDlg',
  'FilenameDlg' = 'FilenameDlg'
};
